import React, { useEffect } from "react";
import { Popover, Fade, Typography } from "@mui/material";

export default function GuidedPopover({
  anchorEl,
  body,
  anchorOrigin = { vertical: "bottom", horizontal: "left" },
  transformOrigin = { vertical: "top", horizontal: "left" },
}) {
  const open = Boolean(anchorEl);

  useEffect(() => {
    if (open && anchorEl) {
      anchorEl.style.outline = "3px solid red";
      anchorEl.style.borderRadius = "8px";
      anchorEl.style.margin = "3px";
    }

    return () => {
      if (anchorEl) {
        anchorEl.style.outline = "";
        anchorEl.style.borderRadius = "";
        anchorEl.style.margin = "";
      }
    };
  }, [open, anchorEl]);

  if (!body) return;

  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      TransitionComponent={Fade}
      transitionDuration={300}
      anchorOrigin={anchorOrigin}
      transformOrigin={transformOrigin}
      disableEnforceFocus
      disableAutoFocus
      PaperProps={{
        sx: {
          transform: `translate(${transformOrigin.horizontal === "left" ? "1" : transformOrigin.horizontal === "right" ? "-1" : "0"}rem, ${transformOrigin.vertical === "top" ? "1" : transformOrigin.vertical === "bottom" ? "-1" : "0"}rem)`,
          padding: "1rem",
          maxWidth: 400,
          textAlign: "center",
        },
      }}
    >
      <Typography variant="body2">{body}</Typography>
    </Popover>
  );
}
